import React from 'react'

export const otherallergies:string[] = [

"Pollen ",
"Dust Mites",
"Pet Dander ",
"Mold Spores",
"Insect Stings",
"Latex",
"Chemicals",
"Pollution",
"Smoke",
"Weeds",
"Nickel",
"Fragrances",
"Lanolin",
"Cosmetic Ingredients",
"Detergents",
"Shampoo Ingredients",
"Sun Allergies",
"Hair Dyes",
'Other (Please specify)'
];